import { render, staticRenderFns } from "./AdminSample.vue?vue&type=template&id=afa3f3ee"
import script from "./AdminSample.vue?vue&type=script&lang=js"
export * from "./AdminSample.vue?vue&type=script&lang=js"
import style0 from "./AdminSample.vue?vue&type=style&index=0&id=afa3f3ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports